import { useState } from "react";
import { Card } from "antd";
import { useEffect } from "react";
import { YookassaButtonModal } from "src/enitities/Integration";

const { Meta } = Card;

export default function IntegrationYookassa({ query, websocket }) {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState({});

  useEffect(() => {}, []);

  return (
    <Card
      style={{ width: 250 }}
      cover={
        <div
          style={{
            display: "flex",
            height: 250,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgb(0, 112, 240)",
            color: "white",
          }}>
          <h3>Юкасса</h3>
        </div>
      }
      actions={[<YookassaButtonModal name="Установить виджет" query={query} websocket={websocket} />]}>
      <Meta title="Юкасса" description={""} />
    </Card>
  );
}
